import useApi from 'common/hooks/useApi';
import { GroupDetailsContext } from 'features/group-details/GroupDetailsContainer';
import { useEffect } from 'react';
import { Spinner } from 'react-bootstrap';
import { Redirect, useRouteMatch } from 'react-router-dom';
import RegistrationDetailsPresenter from './RegistrationDetailsPresenter';
import GroupDetailsResponse from 'features/group-details/GroupDetailsResponse';

function RegistrationDetailsContainer() {
  const {
    params: { refKey },
  } = useRouteMatch<{ refKey: string }>();

  const [res, request] = useApi<GroupDetailsResponse>({
    url: `/applications/groups/${refKey}`,
    method: 'GET',
  });

  useEffect(() => {
    request();
  }, [request]);

  const isLoadingFinished = !res.loading && res.data;

  if (isLoadingFinished && !res.data?.registrationNum) {
    return <Redirect to={`/applications/groups/${refKey}`} />;
  }

  return (
    <>
      <GroupDetailsContext.Provider value={{ onRefresh: request }}>
        <h2>Registration Details</h2>
        {res.loading && <Spinner animation='border' />}
        {!res.loading && res.data && res.data !== null && (
          <RegistrationDetailsPresenter
            applicationDetails={res.data}
            onRefresh={request}
          />
        )}
      </GroupDetailsContext.Provider>
    </>
  );
}

export default RegistrationDetailsContainer;
